export default __webpack_public_path__ + "static/media/fitness-man-1.b995b5f8.png";